export function convertToNewCdnUrl(url: string) {
    return url.replace('https://res.cloudinary.com/dkyrlxgbn', 'https://media.goodseeker.com')
};